/* HandyMite V4.7 behavior fixes: QA reveal mode, PDP details default state, empty reading sections. */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('hm_qa') === '1') {
      document.documentElement.classList.add('hm-v47-qa');
    }
  } catch (e) {}

  function normalizeProductDetails() {
    document.querySelectorAll('.hm-details2').forEach(function (root) {
      var details = root.querySelectorAll('.hm-details2__list > details');
      details.forEach(function (detail, index) {
        if (index === 0) {
          detail.setAttribute('open', '');
        } else {
          detail.removeAttribute('open');
        }
      });

      var lead = root.querySelector('.hm-details2__lead');
      if (lead) {
        lead.textContent = '特徴・サイズ・お手入れ・配送について、必要な情報をまとめました。最初の項目だけ開いています。必要な項目をタップしてご確認ください。';
      }
    });
  }

  function removeEmptyReadingSections() {
    document.querySelectorAll('.hm-bi__section, .hm-read__section').forEach(function (section) {
      if (!section.querySelector('.hm-bi__empty, .hm-read__empty')) return;
      var id = section.getAttribute('id');
      if (id) {
        document.querySelectorAll('a[href="#' + id + '"]').forEach(function (link) {
          link.remove();
        });
      }
      section.remove();
    });
  }

  function markAdaptiveGrids() {
    document.querySelectorAll('.hm-bi__grid, .hm-read__grid, .hm-read__cats').forEach(function (grid) {
      grid.classList.remove('hm-v47-count-1', 'hm-v47-count-2', 'hm-v47-count-3');
      var count = grid.children.length;
      if (count === 1) grid.classList.add('hm-v47-count-1');
      if (count === 2) grid.classList.add('hm-v47-count-2');
      if (count >= 3) grid.classList.add('hm-v47-count-3');
    });
  }

  function applyV47() {
    normalizeProductDetails();
    removeEmptyReadingSections();
    markAdaptiveGrids();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyV47, { once: true });
  } else {
    applyV47();
  }
})();
